<script>
import errorNotification from "./components/errorNotification";
import progressBar from "./components/progressBar";

export default {
  name: "Navbar",
  components: { errorNotification, progressBar },
  methods: {
    routeToFirewall() {},
  },
};
</script>

<template>
  <v-app id="app" style="background:#eee;">
    <router-view></router-view>

    <errorNotification />
    <progressBar />
  </v-app>
</template>

<style>
html {
  overflow: auto !important;
}

a {
  text-decoration: none !important;
}
</style>
